import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokolhapurcab() {



const cardData = {
  keyword: " Mumbai to Kolhapur Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Kolhapur cab services, ensuring a smooth, convenient, and stress‑free journey to the cultural and historic city of Kolhapur. Our professional drivers, well‑maintained vehicles, and punctual pickups make traveling from Mumbai to Kolhapur easy and enjoyable. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for your Mumbai to Kolhapur cab travel.",

topPlaces: [
  {
    title: "Mahalaxmi Temple",
    description: "Mahalaxmi Temple is one of Kolhapur’s most revered and ancient temples dedicated to Goddess Mahalaxmi (Ambabai). Travelers from Mumbai can take a cab to this sacred site to participate in darshan, witness traditional rituals, and experience the divine spiritual atmosphere. The temple’s intricate architecture, religious significance, and serene surroundings make it a must‑visit destination for devotees and cultural tourists."
  },
  {
    title: "Rankala Lake",
    description: "Rankala Lake is a scenic and tranquil lake located in the heart of Kolhapur. Cab travelers from Mumbai can enjoy leisurely walks along the lakeside promenade, boating on calm waters, and capturing picturesque views of the surrounding landscape. The area also features gardens, food stalls, and seating spots ideal for relaxation and family outings."
  },
  {
    title: "New Palace Museum",
    description: "The New Palace Museum is a historic landmark and cultural attraction in Kolhapur that showcases royal artifacts, weapons, paintings, and ceremonial items from the city’s past. Travelers using a Mumbai to Kolhapur cab can explore the museum to learn about Kolhapur’s rich heritage, history of the royal family, and traditional Maharashtrian culture. The beautifully preserved architecture and exhibits make it a fascinating stop for history enthusiasts."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is a majestic hill fort near Kolhapur known for its historic significance and strategic architecture. Cab travelers from Mumbai can visit Panhala Fort to explore its ancient walls, bastions, and scenic viewpoints overlooking the surrounding valleys and landscapes. The fort’s long history, panoramic views, and trekking trails make it ideal for adventure lovers and history buffs."
  },
  {
    title: "Bhavani Mandap",
    description: "Bhavani Mandap is a beautiful historic building located near the Mahalaxmi Temple in Kolhapur. Travelers arriving from Mumbai can explore its exquisite stone pillars, traditional design, and cultural exhibits. The site often hosts cultural events, performances, and art displays that offer insights into local history and heritage. It’s a great stop for visitors interested in architecture and cultural experiences."
  },
  {
    title: "Gaganbawda Viewpoint",
    description: "Gaganbawda Viewpoint is a scenic spot near Kolhapur that offers sweeping views of the Western Ghats, lush valleys, and rolling hills. Travelers from Mumbai can enjoy the peaceful landscape, fresh mountain air, and panoramic photography opportunities. The drive to the viewpoint itself is scenic and filled with natural beauty, making it ideal for nature enthusiasts."
  },
  {
    title: "Jyotiba Temple",
    description: "Jyotiba Temple is a revered hilltop shrine near Kolhapur dedicated to Lord Jyotiba (a form of Lord Shiva). Cab travelers from Mumbai can visit the temple to experience devotional rituals, scenic views, and a serene spiritual environment. The temple’s elevated location provides excellent vantage points for sunrise and sunset photography."
  },
  {
    title: "Shalini Palace",
    description: "Shalini Palace is a historic and picturesque palace located on the shores of Lake Panhala, known for its elegant architecture and tranquil surroundings. Travelers using a cab from Mumbai can explore the palace grounds, enjoy scenic views of the lake, and appreciate the blend of colonial and traditional design. It’s a peaceful spot for photography, leisure walks, and cultural appreciation."
  },
  {
    title: "Rajarshi Shahu Museum",
    description: "Rajarshi Shahu Museum is a cultural museum in Kolhapur dedicated to the legacy of the great ruler Rajarshi Shahu Maharaj. Cab travelers from Mumbai can explore galleries displaying historical artifacts, sculptures, paintings, and documents related to the region’s heritage. The museum offers insightful exhibits for those interested in Kolhapur’s history and leadership."
  },
  {
    title: "Kolhapur Zoo",
    description: "Kolhapur Zoo is a family‑friendly attraction featuring a variety of animal species, lush greenery, and recreational spaces. Travelers from Mumbai using a cab can take children and family members to the zoo for an enjoyable day of animal sightings, nature strolls, and outdoor fun. It’s a great stop for families with kids looking to combine leisure and travel."
  }
],



services: [
{
name: "Mumbai to Kolhapur Cab Service",
description: "Mumbai to Kolhapur cab service offers a smooth and comfortable journey to one of Maharashtra’s most culturally rich cities known for Mahalaxmi Temple, historic forts, and authentic cuisine. This service is ideal for families, pilgrims, and business travelers planning a long-distance road trip from Mumbai. The route includes well-maintained highways and scenic landscapes, making the journey pleasant and relaxing. Professional drivers experienced in long-distance travel ensure safe driving and timely arrival at the destination. Customers can choose from sedan, SUV, and premium vehicles based on their travel needs and group size. Flexible pickup options from home, airport, or railway station add convenience to the journey. With transparent pricing, easy booking, and 24x7 availability, this cab service ensures a hassle-free and enjoyable travel experience."
},
{
name: "Mumbai to Kolhapur Taxi",
description: "Mumbai to Kolhapur taxi service provides reliable and comfortable transportation for long-distance travel with well-maintained vehicles and experienced drivers. This service is perfect for travelers who prefer private travel with door-to-door pickup and drop convenience. Flexible scheduling allows customers to choose travel timings as per their plan. Multiple vehicle options are available including sedan, SUV, and luxury cars. Regular stops for refreshments make the journey comfortable. With affordable pricing and easy booking options, this taxi service ensures a smooth and relaxing trip."
},
{
name: "One Way Cab Mumbai to Kolhapur",
description: "One way cab Mumbai to Kolhapur is a cost-effective option for travelers who need a single-side drop without return charges. This service is ideal for those planning to stay in Kolhapur or continue their journey further. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure safe and timely travel on highways. Sedan and SUV options are available based on travel needs. Easy online booking and instant confirmation make this service highly convenient."
},
{
name: "Mumbai to Kolhapur Cab Booking",
description: "Mumbai to Kolhapur cab booking allows travelers to reserve their cab quickly with instant confirmation and flexible travel schedules. Customers can choose vehicle types, travel dates, and pickup locations as per their convenience. Transparent pricing ensures no hidden charges during the journey. Online booking platforms provide a hassle-free experience with secure payment options. Dedicated support is available for assistance before and during travel. It is the easiest way to plan your Kolhapur trip."
},
{
name: "Mumbai to Kolhapur Outstation Taxi",
description: "Mumbai to Kolhapur outstation taxi service provides long-distance travel solutions with comfort and safety. This service is ideal for tourists and business travelers who want a smooth intercity journey. Vehicles are well-maintained for performance on highways. Flexible pickup options and travel schedules add convenience. Travelers can choose between one way and round trip packages. It ensures a stress-free and enjoyable travel experience."
},
{
name: "Cheap Cab Mumbai to Kolhapur",
description: "Cheap cab Mumbai to Kolhapur offers budget-friendly travel options without compromising on comfort and safety. This service is perfect for cost-conscious travelers who want reliable transportation at affordable rates. Economical sedan options are available for lower fares. Transparent pricing and no hidden charges make this service popular among travelers. Professional drivers ensure safe and smooth travel. It is an ideal choice for budget trips."
},
{
name: "Mumbai to Kolhapur SUV Taxi",
description: "Mumbai to Kolhapur SUV taxi is ideal for group travel and those seeking extra space and comfort during long journeys. SUVs provide spacious seating and better performance on highways, making them perfect for long-distance travel. This option is suitable for families, friends, and corporate groups. Drivers are experienced in long routes ensuring safety. It offers a premium and comfortable travel experience. Perfect for extended road trips."
},
{
name: "Mumbai to Kolhapur Sedan Cab",
description: "Mumbai to Kolhapur sedan cab is perfect for small families and couples looking for an affordable and comfortable ride. Sedans offer smooth travel, good mileage, and comfortable seating for long-distance journeys. This option is ideal for budget-friendly travel without compromising on convenience. Professional drivers ensure safe driving throughout the route. Easy booking and flexible timing enhance the travel experience. It is one of the most preferred options."
},
{
name: "Mumbai to Kolhapur Taxi Fare",
description: "Mumbai to Kolhapur taxi fare is designed to be transparent and competitive, helping travelers plan their budget effectively. Pricing varies based on vehicle type, distance, and trip duration. Customers receive clear cost breakdowns including tolls and driver allowance where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. It offers excellent value for a comfortable journey."
},
{
name: "AC Cab Mumbai to Kolhapur",
description: "AC cab Mumbai to Kolhapur ensures a comfortable journey in air-conditioned vehicles, especially during long-distance travel. This service provides a pleasant environment inside the vehicle regardless of weather conditions. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible pickup options add convenience. It guarantees a relaxing travel experience."
},
{
name: "Private Taxi Mumbai to Kolhapur",
description: "Private taxi Mumbai to Kolhapur offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules based on their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating and premium service enhance the experience. It is ideal for a private and luxurious road trip."
}
],

tableData: [
["Mumbai to Kolhapur Cab Service","Mumbai to Kolhapur Taxi"],
["One Way Cab Mumbai to Kolhapur","Mumbai to Kolhapur Cab Booking"],
["Mumbai to Kolhapur Outstation Taxi","Cheap Cab Mumbai to Kolhapur"],
["Mumbai to Kolhapur SUV Taxi","Mumbai to Kolhapur Sedan Cab"],
["Mumbai to Kolhapur Taxi Fare","AC Cab Mumbai to Kolhapur"],
["Private Taxi Mumbai to Kolhapur","Mumbai to Kolhapur Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Long Distance Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mumbai to Kolhapur cab services, perfect for family trips, business travel, and religious visits with a smooth and comfortable journey."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance highway routes between Mumbai and Kolhapur, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Kolhapur cab bookings. Customers receive complete fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Kolhapur cab service operates 24/7. Whether you plan early morning travel or overnight journeys, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized travel plans for Mumbai to Kolhapur trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Kolhapur cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Kolhapur cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Kolhapur for one-way and round-trip travel." },
  { question: "How far is Kolhapur from Mumbai?", answer: "The distance between Mumbai and Kolhapur is approximately 375 km and the journey takes around 7 to 8 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Kolhapur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Kolhapur." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Kolhapur cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback:
      "Comfortable and well-managed journey from Mumbai to Kolhapur. The cab was on time, the ride was smooth, and the overall travel experience felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Mumbai to Kolhapur cab service was very reliable. The vehicle was clean, the drive was steady, and everything was handled in a professional and stress-free way.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const mumbaiKolhapurJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Kolhapur Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Kolhapur for outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Kolhapur Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Kolhapur",
        "description": "Private cab from Mumbai to Kolhapur for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Kolhapur Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Kolhapur with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai to Kolhapur Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Kolhapur for outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiKolhapurJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokolhapurcab;